var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBigIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4937 22.9167C35.7366 22.9167 22.9167 35.7366 22.9167 51.4937C22.9167 67.2508 35.7366 80.0707 51.4937 80.0707C57.9227 80.0707 63.8453 77.9147 68.6182 74.3235L80.2002 85.9021C80.9863 86.6881 82.0194 87.0834 83.0511 87.0834C84.0828 87.0834 85.1159 86.6881 85.902 85.902C87.4784 84.3256 87.4783 81.7766 85.902 80.2002L74.3235 68.6182C77.9147 63.8453 80.0707 57.9227 80.0707 51.4937C80.0707 35.7366 67.2508 22.9167 51.4937 22.9167ZM30.9814 51.4937C30.9814 40.1816 40.1816 30.9814 51.4937 30.9814C62.8058 30.9814 72.006 40.1816 72.006 51.4937C72.006 62.8058 62.8058 72.006 51.4937 72.006C40.1816 72.006 30.9814 62.8058 30.9814 51.4937Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBigIco);
export default __webpack_public_path__ + "static/media/search-big-ico.674e7b30dbe67200632fb2cf3eb571f4.svg";
export { ForwardRef as ReactComponent };